import PropTypes from 'prop-types';
import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from 'contexts/AuthContext';

const GuestGuard = ({ children }) => {
  const { isLoggedIn, isInitialized } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (isInitialized) {
      if (isLoggedIn) {
        navigate('/dashboard', { replace: true });
      } else if (localStorage.getItem('gpo_admin_token')) {
        navigate('/admin/merchants', { replace: true });
      }
    }
  }, [isLoggedIn, isInitialized, navigate]);

  if (!isInitialized) return <div>A carregar...</div>;

  return children;
};

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default GuestGuard;
